<template>
    <section
        class="cta section center-content-mobile"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="cta-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider',
                    split && 'cta-split'
                ]">
                <div class="cta-slogan reveal-from-left">
                    <h3 class="m-0">
                        Ready to clear your next shipment?
                    </h3>
                </div>
                <div class="cta-action reveal-from-right">
                    <router-link to="/contact/" class="button button-primary button-wide-mobile">
                        Contact Us
                    </router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'

export default {
  name: 'CCta',
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  }
}
</script>